module.exports = __webpack_public_path__ + "img/1212e_1.4aee8e88.jpg";